
import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Heart, Shield, Zap } from 'lucide-react';
import { Card3D, ScrollReveal } from '@/components/ui/premium';

const features = [
  { icon: Sparkles, label: 'IA Empática', color: 'from-yellow-400 to-orange-500' },
  { icon: Shield, label: '100% Privado', color: 'from-green-400 to-emerald-500' },
  { icon: Heart, label: 'Baseado em Ciência', color: 'from-red-400 to-red-500' },
  { icon: Zap, label: 'Resultados Rápidos', color: 'from-red-500 to-red-600' }
];

export const HeroFeatures = () => {
  return (
    <ScrollReveal animation="fade" delay={1.4}>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 max-w-4xl mx-auto mb-16">
        {features.map((feature, index) => (
          <motion.div
            key={feature.label}
            initial={{ opacity: 0, y: 50, rotateY: -90 }}
            animate={{ opacity: 1, y: 0, rotateY: 0 }}
            transition={{ 
              delay: 1.6 + index * 0.1,
              duration: 0.8,
              type: 'spring',
              stiffness: 100
            }}
            whileHover={{ 
              scale: 1.1, 
              rotateY: 15,
              transition: { duration: 0.2 }
            }}
            className="flex flex-col items-center group"
          >
            <Card3D className="p-6 mb-4 group-hover:shadow-2xl transition-all duration-300">
              <motion.div
                className={`w-16 h-16 rounded-2xl bg-gradient-to-br ${feature.color} flex items-center justify-center shadow-xl`}
                whileHover={{ rotate: 360 }}
                transition={{ duration: 0.6 }}
              >
                <feature.icon className="w-8 h-8 text-white" />
              </motion.div>
            </Card3D>
            <span className="text-sm font-spartan font-medium text-gray-700 group-hover:text-brand-primary transition-colors duration-300">
              {feature.label}
            </span>
          </motion.div>
        ))}
      </div>
    </ScrollReveal>
  );
};
